<template>
  <div>
    <Navigation />
    <slot></slot>
    <Footer />
  </div>
</template>

<script>
import Navigation from './Navigation'
import Footer from './Footer'

export default {
  name: 'DefaultLayout',
  components: { Navigation, Footer }
}
</script>

<style scoped lang="scss">
</style>
